import {
  PRODUCT_UTM_CAMPAIGNS,
  isProductUtmCampaign,
  triggerChiliPiperProductRouter,
} from "@circle-react/components/CommunityOnboarding/NewChecklistComponents/CircleAppLinks/chiliPiperUtils";
import { usePlanStatus } from "@circle-react/hooks/usePlanStatus";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import type { PlusBannerSource } from "@/react/hooks/analytics/types";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { useTanstackRouterQueryParams as useRouterQueryParams } from "@/react/hooks/useRouterQueryParams";

interface PlusPlanCtaButtonProps {
  ctaHref?: string;
  source: PlusBannerSource;
}

export const PlusPlanCtaButton = ({
  source,
  ctaHref,
}: PlusPlanCtaButtonProps) => {
  const { currentCommunityMember } = usePunditUserContext();
  const { trackEvent } = useEventsTracker();
  const { isCommunityOnPaidPlan } = usePlanStatus();
  const { sales_utm_campaign } = useRouterQueryParams();

  const getCampaign = () => {
    if (source === "plans_page") {
      return isCommunityOnPaidPlan
        ? PRODUCT_UTM_CAMPAIGNS.UPGRADE_PLAN_EXP
        : PRODUCT_UTM_CAMPAIGNS.UPGRADE_PLAN;
    }
    return isCommunityOnPaidPlan
      ? PRODUCT_UTM_CAMPAIGNS.USAGE_MODAL_EXP
      : PRODUCT_UTM_CAMPAIGNS.USAGE_MODAL;
  };

  const handleClick = () => {
    trackEvent("enterprise_plus.talk_to_sales.clicked", {
      source,
    });

    if (ctaHref) {
      window.open(ctaHref, "_blank", "noopener");
      return;
    }

    const { email } = currentCommunityMember ?? {};
    if (email) {
      const campaign = isProductUtmCampaign(sales_utm_campaign)
        ? sales_utm_campaign
        : getCampaign();
      void triggerChiliPiperProductRouter(email, campaign);
    }
  };

  return (
    <Button
      variant="marketing-gradient-blue"
      extraLarge
      full
      className="rounded-xl"
      onClick={handleClick}
    >
      {t("pricing_plans.plan_settings.plus_plan_summary.cta_button")}
    </Button>
  );
};
